module.exports = __webpack_public_path__ + "img/cart_unselect.1dd94f95.png";